import { render, staticRenderFns } from "./TaskSortChangePopup.vue?vue&type=template&id=939288a6&scoped=true&lang=pug&"
import script from "./TaskSortChangePopup.vue?vue&type=script&lang=js&"
export * from "./TaskSortChangePopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskSortChangePopup.vue?vue&type=style&index=0&id=939288a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939288a6",
  null
  
)

export default component.exports